export default __webpack_public_path__ + "static/media/css.6e979d9b.png";